import { useEffect, useState } from "react";
import { usinasApi } from "../../../services/api";
import { Usina } from "../types";
import { useNavigate } from "react-router";
import { TableRowType } from "../../../main/components/RopTable/RopTable";
import ListScreen from "../../../main/components/ListScreen";

export default function UsinasList() {
  const [loading, setLoading] = useState(true);
  // const [search, setSearch] = useState("");
  const [usinas, setUsinas] = useState<Usina[]>([]);
  // const [pageIndex, setPageIndex] = useState(0);
  // const page = pageIndex + 1;
  // const [usinasAmount, setUsinasAmount] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(25);
  const navigate = useNavigate();

  useEffect(
    () => {
      mount();
    },
    [
      // pageIndex, search, 25
    ]
  );
  const mount = async () => {
    try {
      setLoading(true);
      const response = await usinasApi
        .getUsinas
        //   // page,
        //   // search,
        //   // undefined,
        //   // 25
        ();
      // if (response.total < page * 25) {
      //   setPageIndex(0);
      // }
      setUsinas(response.data);
      // setUsinasAmount(response.total);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const tableRows: TableRowType[] = usinas.map((e) => {
    return {
      rowItems: [
        {
          item: e.name,
          align: "center",
          isMobile: true,
        },
      ],
      onClick: () => {
        navigate(e.usinaIds.id);
      },
    };
  });

  return (
    <ListScreen
      buttonTilte="Adicionar Usina"
      title="Usinas"
      onClick={() => {
        navigate("cadastrar");
      }}
      // search={search}
      // setSearch={setSearch}
      hover
      isLoading={loading}
      itemsHeaders={[
        {
          item: "Nome",
          align: "center",
          isMobile: true,
        },
      ]}
      itemRows={tableRows}
    // itemsAmount={clientsAmount}
    // rowsPerPage={rowsPerPage}
    // page={pageIndex}
    // setPage={setPageIndex}
    // setRowsPerPage={setRowsPerPage}
    />
  );
}
